// extracted by mini-css-extract-plugin
module.exports = {"arrow":"Accordion_arrow__GsBoi","arrowOpen":"Accordion_arrowOpen__0u6rq","content":"Accordion_content__il9x9","item":"Accordion_item__cLZpD","title":"Accordion_title___CGmZ"};